import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { AlertService, AuthenticationService } from '../_services/index';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {
  loading = false;
  email_input : string;
  email_sent = false;
  
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private alertService: AlertService) { }
  ngOnInit() {
  }
  forgetPass() {
    this.loading = true;
    this.authenticationService.forgetPass(this.email_input)
        .subscribe(
            data => {
              this.loading = false;
              this.email_sent = true;
            },
            error => {
                this.alertService.error(error);
                this.loading = false;
            });
  }
}



// WEBPACK FOOTER //
// ./src/app/forgot-password/forgot-password.component.ts